<template>
  <div class="tabulka full">
    <div class="tabulka__top">
      <div class="tabulka__top__nadpis">{{ options.title }}</div>
    </div>

    <div class="tabulka__body">
      <table>
        <thead>
          <td>
            <span class="tabulka__body__name">Name - code</span>
            <SortButton
              row="id"
              type="a"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
            <input
              type="text"
              name="search"
              v-model="searchQuery"
              placeholder="Search game"
              class="tabulka__body__searchbox"
              autocomplete="off"
            />
          </td>
          <td v-if="options.showTeam">
            <span>Teams</span>
            <SortButton
              row="numberOfTeams"
              type="0"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
          </td>
          <td>
            <span>{{ options.thirdRow }}</span>
            <SortButton
              row="status#statusTypes#name"
              :type="options.thirdRowType"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
          </td>
          <td>
            <span>Rounds</span>
            <SortButton
              row="rounds"
              type="0"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
          </td>
          <td>
            <div
              class="tabulka__body__togglebutton"
              v-on:click="gamesVisible = !gamesVisible"
              :class="{ opened: gamesVisible }"
            >
              <div class="tabulka__body__togglebutton__arrow">
                <div class="tabulka__body__togglebutton__arrow__img"></div>
              </div>
            </div>
          </td>
        </thead>
        <tr v-for="product in resultQuery" :key="product.id">
          <td>
            <div class="table__join-name">
              {{ product.name }} <div v-if="isDemo(product)" class="table__join-name__demo-button">Demo</div>
              <!--              - {{product.code}}-->
            </div>
          </td>
          <td v-if="options.showTeam">
            <div class="table__join-team">{{ product.numberOfTeams }}</div>
          </td>
          <td>
            <div
              class="table__join-status"
              :class="options.statusClass"
              v-if="!product.archived"
            >
              <span :class="getStatus(product).class">{{
                getStatus(product).name
              }}</span>
            </div>
            <div v-else>
              {{ product.archivationDate }}
            </div>
          </td>
          <td>
            <div class="table__join-rounds">
              {{ product.turn }}/{{ product.maxTurn }}
            </div>
          </td>
          <td class="join_button">
            <button
              v-if="displayButton() && !isDemoButton(product) && !activatedDemo(product)"
              class="table-button"
              :class="options.action.class"
              @click="onAction(product)"
            >
              {{ options.action.label }}
            </button>
             <button
              v-else-if="displayButton() && isDemoButton(product)"
              class="table-button"
              :class="options.action.class"
              @click="onAction(product)"
            >
              Activate demo
            </button>
            <button v-else-if="!isDemoButton(product) && !activatedDemo(product)" class="table-button table-button-disabled">
              {{ options.action.label }}
            </button>
            <span v-else>Demo nemá přehled správce</span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import SortButton from "@/components/game/table/SortButton.vue";
import sortingLogicMixin from "@/components/game/table/sortingLogicMixin.js"; // obsahuje logiku k sortovani

export default {
  name: "Campaigns",
  mixins: [sortingLogicMixin],
  components: {
    SortButton,
  },
  props: {
    sourceData: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      required: true,
    },
    activeGameNumber: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      currentSortRow: "id",
      currentSortDirection: -1,
      searchQuery: null,
      gamesVisible: true,
      statusTypes: {
        open: {
          name: "Open",
          class: "open",
        },
        nonactive: {
          name: "Not activated",
          class: "open",
        },
        started: {
          name: "Started",
          class: "started",
        },
        finished: {
          name: "Finished",
          class: "finished",
        },
      },
    };
  },
  computed: {
    resultQuery() {
      if (this.searchQuery) {
        return this.sortedData.slice().filter((item) => {
          if (this.gamesVisible == true) {
            return this.searchQuery
              .toLowerCase()
              .split(" ")
              .every((v) => (item.name.toLowerCase() + item.code).includes(v));
          } else {
            return null;
          }
        });
      } else {
        if (this.gamesVisible == true) {
          return this.sortedData;
        } else {
          return null;
        }
      }
    },
    options() {
      switch (this.type) {
        case "open":
          return {
            title: "My games",
            action: {
              label: "Enter",
              class: "table-button-continue",
            },
            statusClass: "mygame",
            thirdRow: "Status",
            thirdRowType: "a",
            showTeam: false,
          };
        case "archived":
          return {
            title: "Archived games",
            action: {
              label: "Review",
              class: "table-button-review",
            },
            statusClass: "archivegame",
            thirdRow: "Archived",
            thirdRowType: "0",
            showTeam: false,
          };
        case "active":
          return {
            title: "Active game",
            action: {
              label: "Enter",
              class: "table-button-continue",
            },
            statusClass: "mygame",
            thirdRow: "Status",
            thirdRowType: "a",
            showTeam: false,
          };
        case "nonactive":
          return {
            title: "My games",
            action: {
              label: "Activate",
              class: "table-button-continue",
            },
            statusClass: "mygame",
            thirdRow: "Status",
            thirdRowType: "a",
            showTeam: false,
          };
        default:
          return {};
      }
    },
  },
  methods: {
    onAction(game) {
      this.$emit("action", game);
    },
    getStatus(game) {
      if (game.endedTime) {
        return this.statusTypes.finished;
      } else if (game.startedTime) {
        return this.statusTypes.started;
      } else if (!game.active) {
        return this.statusTypes.nonactive;
      }

      return this.statusTypes.open;
    },

    displayButton() {
      if (this.type == "active") {
        return true;
      }
      if (this.type == "nonactive" && this.activeGameNumber == 0) {
        return true;
      }
      if (this.type == "archived") {
        return true;
      }
      return false;
    },

    isDemo(product){
      if(product.type == "DEMO"){
        return true
      }else{
        return false
      }
    },
    isDemoButton(product){
      if(product.type == "DEMO" && this.type == "nonactive" ){
        return true
      }else{
        return false
      }
    },
    activatedDemo(product){
      if(product.type == "DEMO" && this.type == "active" ){
        return true
      }else{
        return false
      }
    }
  },
};
</script>
